var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCaretDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 5.33337L4.03133 5.33337C3.34972 5.33337 2.93557 5.84791 3.30658 6.24417L7.7759 11.0584C8.11239 11.425 8.88891 11.425 9.23403 11.0584L13.6947 6.24417C14.0657 5.84791 13.6516 5.33337 12.97 5.33337Z",
    fill: "#1C1C1C",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaretDownGrey);
export default __webpack_public_path__ + "static/media/ic-caret-down-grey.94d6f66ed1f1ddc5e0464165b1358950.svg";
export { ForwardRef as ReactComponent };